export const normalizeSearchText = value => String(value ?? "")
    .normalize("NFKC")
    .toLocaleLowerCase()
    .replace(/\s+/g, "")
    .trim();

export const fuzzyIncludes = (value, query) => {
    const source = normalizeSearchText(value);
    const target = normalizeSearchText(query);
    if (!target) return true;
    if (source.includes(target)) return true;

    let targetIndex = 0;
    for (let i = 0; i < source.length && targetIndex < target.length; i += 1) {
        if (source[i] === target[targetIndex]) targetIndex += 1;
    }
    return targetIndex === target.length;
};

export const matchesInstrumentSearch = (row, query) => fuzzyIncludes([
    row.pointIdx,
    row.pointNo,
    row.area,
    row.nickname,
    row.tagNames
].join(" "), query);
